<script lang="ts" setup>
import { CircleClose } from '@element-plus/icons-vue'
</script>

<template>
    <el-menu-item :disabled="true">
        <el-icon>
            <CircleClose />
        </el-icon>
        <template #title>
            <span>Not available!</span>
        </template>
    </el-menu-item>
</template>
